module.exports = __webpack_public_path__ + "img/story023@2x.375fb614.png";